import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Admin from './Admin';
import Show from './Show';
import Work from "./Works"
import NotFound from './NotFound';
import "./styles/main.css";
import "./styles/responsive.css"
import { createBrowserRouter, RouterProvider } from "react-router-dom";
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/works",
    element: <Work />,
  },
  {
    path: "/Show",
    element: <Show />,
  },
  {
    path: "/secret",
    element: <Admin />,
  },
  {
    path: "/#About",
    element: <App />,
  },
  {
    path: "*",
    element: <NotFound />
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider baseName="/" router={router} />
  </React.StrictMode>
);